import React, { useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Button,
  Collapse,
  ListItem,
  Typography,
  makeStyles
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { Icon } from '@iconify/react';
import { Box } from '@mui/material';
import getName from 'src/utils/getName';

const useStyles = makeStyles(theme => ({
  item: {
    display: 'block',
    paddingTop: 0,
    paddingBottom: 0
  },
  itemLeaf: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: '#757575',
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%'
  },
  buttonLeaf: {
    color: '#757575',
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover': {
      backgroundColor: "#bdbdbd", // Add your desired hover styles here
    },
    '&.depth-0': {
      '& $title': {
        // fontWeight: theme.typography.fontWeightMedium
      }
    }
  },
  buttonLeafN: {
    // color: '#757575',
    // padding: '10px 8px',
    // justifyContent: 'flex-start',
    // textTransform: 'none',
    // letterSpacing: 0,
    // width: '100%',
    // fontWeight: theme.typography.fontWeightRegular,
    // '&:hover': {
    //   backgroundColor:"#eeeeee", // Add your desired hover styles here
    // },
    // '&.depth-0': {
    //   '& $title': {
    //     // fontWeight: theme.typography.fontWeightMedium
    //   }
    // }
    color: '#757575',
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover': {
      backgroundColor: "#bdbdbd", // Add your desired hover styles here
    },
    '&.depth-0': {
      '& $title': {
        // fontWeight: theme.typography.fontWeightMedium
      }
    }
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(3)
  },
  title: {
    marginRight: 'auto'
  },
  active: {
    backgroundColor: '#bdbdbd',
    color: "#002F6D",
    '& $title': {
      fontWeight: 500
    },
    '& $icon': {
      color: theme.palette.secondary.main
    }
  },
  activeN: {
    // backgroundColor: '#eeeeee',
    // color: "#002F6D",
    // '& $title': {
    //   fontWeight: 500
    // },
    // '& $icon': {
    //   color: theme.palette.secondary.main
    // }
    backgroundColor: '#bdbdbd',
    color: "#002F6D",
    '& $title': {
      fontWeight: 500
    },
    '& $icon': {
      color: theme.palette.secondary.main
    }
  }
}));

const NavItem = ({
  children,
  className,
  depth,
  href,
  icon: NavIcon,
  info: Info,
  open: openProp,
  title,
  ...rest
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(openProp);

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  let paddingLeft = 8;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  const style = { paddingLeft };

  if (children) {
    return (
      <>
      <ListItem
        className={clsx(classes.item, className)}
        disableGutters
        key={title}
        {...rest}
      >
        <Button className={classes.button} onClick={handleToggle} style={style}>
          {NavIcon && (
            <Icon
              icon={NavIcon}
              style={{
               
                fontSize: '25px',
                marginRight: '10px',
                marginBottom: '2px'
              }}
            />
          )}
          <Typography variant="body2" className={classes.title}>
            {getName(title)}
          </Typography>
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          {Info && <Icon
            icon={Info}
            style={{
              
              fontSize: '25px',
              marginRight: '10px',
              marginBottom: '2px'
            }}
          />}
        </Button>
        <Collapse in={open}>{children}</Collapse>
      </ListItem>
       <Box mt={0.5}/>
       </>
    );
  }

  return (
    <>
    <ListItem
      className={clsx(classes.itemLeaf, className)}
      disableGutters
      key={title}
      {...rest}
    >
      <Button
        activeClassName={window.location.pathname.includes('fee_settings')?classes.activeN:classes.active}
        
        className={clsx(window.location.pathname.includes('fee_settings')?classes.buttonLeafN:classes.buttonLeaf, `depth-${depth}`)}
        component={RouterLink}
        exact
        style={style}
        to={href}
      >
        {NavIcon && (
          <Icon
            icon={NavIcon}
            style={{
              fontSize: '20px',
              marginRight: '10px',
              marginBottom: '2px'
            }}
          />
        )}
        <Typography
          variant="body2"
          className={classes.title}
        >
          {getName(title)}
        </Typography>
        {Info && <Icon
            icon={Info}
            style={{
              fontSize: '20px',
              marginRight: '10px',
              marginBottom: '2px'
            }}
          />}
      </Button>
    </ListItem>
    <Box mt={0.5}/>
    </>
  );
};

NavItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  info: PropTypes.elementType,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired
};

NavItem.defaultProps = {
  open: false
};

export default NavItem;
